import first from "lodash/first";
import type { FunctionComponent } from "react";
import type { PreloadedQuery } from "react-relay";
import { graphql, useFragment, usePreloadedQuery } from "react-relay";

import { query } from "~/components/article/article-render/style-article/digital-archive-link";
import type { digitalArchiveLinkStyleArticleCheckPathQuery } from "~/queries/__generated__/digitalArchiveLinkStyleArticleCheckPathQuery.graphql";
import type { digitalArchiveLinkTopicUrlPath$key } from "~/queries/__generated__/digitalArchiveLinkTopicUrlPath.graphql";

export type Props = {
  queryReference: PreloadedQuery<digitalArchiveLinkStyleArticleCheckPathQuery>;
};

export const DigitalArchiveLinkTopic: FunctionComponent<Props> = ({ queryReference }) => {
  const content = usePreloadedQuery(query, queryReference);

  const data = useFragment<digitalArchiveLinkTopicUrlPath$key>(
    graphql`
      fragment digitalArchiveLinkTopicUrlPath on UrlPath {
        ... on UrlPath {
          item {
            ... on Content {
              topics {
                name
              }
            }
          }
        }
      }
    `,
    content.checkPath ?? null,
  );

  const firstTopic = first(data?.item?.topics);
  if (!firstTopic) return null;
  return <>{firstTopic.name}</>;
};

DigitalArchiveLinkTopic.displayName = "DigitalArchiveLinkTopic";
